import { toast } from "sonner";

// Sonner's own default `visibleToasts` is 3 (VISIBLE_TOASTS_AMOUNT in
// sonner's source). Keeping this cap in lockstep means a "pending" toast is
// always a visible, clickable one — nothing is ever queued past what sonner
// itself would render. If sonner's default ever changes, this must move
// with it (or the Toaster mount in main.tsx must pin visibleToasts={3}
// explicitly).
const MAX_PENDING_CHAT_READY_TOASTS = 3;

// Remote thread ids with a currently pending "Chat ready" toast, oldest
// first. Module-level, mirroring the activeSheetThreadId store in
// runtime-provider.sheet-mode.ts — intentionally does not survive a reload.
const pendingThreadIds: string[] = [];

export function reserveChatReadyToastSlot(remoteId: string): void {
    if (pendingThreadIds.includes(remoteId)) return;
    if (pendingThreadIds.length >= MAX_PENDING_CHAT_READY_TOASTS) {
        const oldest = pendingThreadIds.shift();
        if (oldest !== undefined) toast.dismiss(oldest);
    }
    pendingThreadIds.push(remoteId);
}

export function forgetChatReadyToast(remoteId: string): void {
    const index = pendingThreadIds.indexOf(remoteId);
    if (index !== -1) pendingThreadIds.splice(index, 1);
}

export function clearChatReadyToast(remoteId: string): void {
    const index = pendingThreadIds.indexOf(remoteId);
    if (index === -1) return;
    pendingThreadIds.splice(index, 1);
    toast.dismiss(remoteId);
}

export function resetChatReadyToastRegistryForTests(): void {
    pendingThreadIds.length = 0;
}
